import { apiClient } from "@/lib/api/client";

export type SystemHealthServiceDto = {
  id: string;
  service_name: string;
  status: string;
  value: string;
  note: string;
  sort_order: number;
  updated_at: string;
};

export type SystemHealthIncidentDto = {
  id: string;
  title: string;
  description: string;
  severity: string;
  occurred_at: string;
};

export type SystemHealthIngestPointDto = {
  id: string;
  sample_label: string;
  sample_value: number;
  sort_order: number;
  recorded_at: string;
};

export type SystemHealthOverviewDto = {
  services: SystemHealthServiceDto[];
  incidents: SystemHealthIncidentDto[];
  ingest_points: SystemHealthIngestPointDto[];
};

export type RuntimeHealthCheckDto = {
  status: string;
  detail?: string;
  [key: string]: unknown;
};

export type RuntimeHealthDto = {
  status: "healthy" | "unhealthy" | string;
  checks: {
    database?: RuntimeHealthCheckDto;
    background_tasks?: Record<string, RuntimeHealthCheckDto>;
    [key: string]: unknown;
  };
};

export async function getSystemHealthOverview(): Promise<SystemHealthOverviewDto> {
  const { data } = await apiClient.get<SystemHealthOverviewDto>("/system-health");
  return data;
}

export async function getRuntimeHealth(): Promise<RuntimeHealthDto> {
  const { data } = await apiClient.get<RuntimeHealthDto>("/health", {
    __skipTenantHeader: true,
    validateStatus: (status) => status >= 200 && status < 600,
  });
  return data;
}
